// extracted by mini-css-extract-plugin
module.exports = {"root":"_3EP6gLk","appIconPlaceHolder":"vwOmdmr","appStoreText":"Ukcp1U6","noThanks":"_1dc5AAd","quote":"ic1frpX","openingQuote":"_3hs8YwR","closingQuote":"_18WSXH3"};
    if(module.hot) {
      // 1545369455106
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  